import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    directionName: "", // 页面切换方向: slide-left 左滑前进, slide-right 右滑后退
    routeStack: [] // 储存路由栈
  },
  getters: {
    directionName(state) {
      return state.directionName || "";
    },
    routeStack(state) {
      return state.routeStack || [];
    }
  },
  mutations: {
    PUSH_ROUTE_STACK(state, route) {
      state.routeStack.push(JSON.parse(JSON.stringify(route)));
    },
    POP_ROUTE_STACK(state) {
      state.routeStack.pop();
    },
    SET_DIRECRTION_NAME(state, direction) {
      state.directionName = direction;
    }
  },
  actions: {
    // 记录页面前进/后退
    handleRouteChange({ getters, commit }, payload) {
      const { to, from } = payload;
      let len = getters.routeStack.length;
      if (len === 0) {
        const homePath = "/index"; // 项目首页的路由，换成你自己的
        if (to.path === homePath) {
          // 直接打开首页
          commit("PUSH_ROUTE_STACK", to);
        } else {
          // 直接打开非首页
          commit("PUSH_ROUTE_STACK", { path: homePath });
          commit("PUSH_ROUTE_STACK", to);
        }
      } else if (len === 1) {
        // 先打开首页，再打开其他路由
        commit("SET_DIRECRTION_NAME", "slide-left");
        commit("PUSH_ROUTE_STACK", to);
      } else {
        let lastBeforeRoute = getters.routeStack[len - 2];
        if (lastBeforeRoute.path === to.path) {
          // 打开上一页路由，后退
          commit("POP_ROUTE_STACK");
          commit("SET_DIRECRTION_NAME", "slide-right");
        } else {
          // 前进
          commit("PUSH_ROUTE_STACK", to);
          commit("SET_DIRECRTION_NAME", "slide-left");
        }
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js